<template>
  <div class="order-detail" v-loading="loading">
    <div class="page-group">
      <el-button
        class="page-btn"
        size="small"
        icon="el-icon-arrow-left"
        :disabled="pageIndex === 0"
        @click="onPage(-1)"
      ></el-button>
      <el-button
        class="page-btn"
        size="small"
        icon="el-icon-arrow-right"
        :disabled="!pageList || pageIndex === pageList.length - 1"
        @click="onPage(1)"
      ></el-button>
    </div>
    <el-row :gutter="16">
      <el-col :lg="16" :md="16" :sm="12" class="detail-wrapper">
        <el-card>
          <div class="title-line" slot="header">
            <span class="card-title">{{ $t('stores::order::order_info') }}</span>
            <div class="right-ctl-wrapper">
              <el-button
                @click="isCancelModalShow = true"
                class="ctl-btn"
                size="small"
                v-auth="'stores::order::cancel'"
                v-if="orderDetail.payStatus === 0"
              >
                {{ $t('stores::order::cancel_order') }}
              </el-button>
              <el-button
                @click="$router.push({ path: '/add-after-order', query: { orderNo: $route.params.id } })"
                class="ctl-btn"
                size="small"
                v-auth="'stores::order::after'"
                v-if="[1].some(i => i === orderDetail.payStatus) && [0].some(i => i === orderDetail.salesStatus)"
              >
                {{ $t('stores::order::to_after_sales') }}
              </el-button>
            </div>
          </div>
          <el-row :gutter="16" class="row-item">
            <el-col :span="12" class="mb-16">
              {{ $t('stores::order::platform_order') }}：
              <span>{{ $dataCheck(orderDetail.orderNo) }}</span>
            </el-col>
            <el-col :span="12" class="mb-16">
              {{ $t('stores::order::belong_platform') }}：
              <span>{{ $dataCheck(PLATFORM[orderDetail.mallType]) }}</span>
            </el-col>
            <el-col :span="12" class="mb-16">
              {{ $t('stores::order::belong_store') }}：
              <span>{{ $dataCheck(orderDetail.shopName) }}</span>
            </el-col>
            <el-col :span="12" class="mb-16">
              {{ $t('stores::order::store_order') }}：
              <span>{{ $dataCheck(orderDetail.sourceNo) }}</span>
            </el-col>
            <el-col :span="12" class="mb-16">
              {{ $t('stores::order::create_time') }}：
              <span>{{ $dataCheck(orderDetail.createTime) }}</span>
            </el-col>
            <el-col :span="12" class="mb-16">
              {{ $t('stores::order::order_time') }}：
              <span>{{ $dataCheck(orderDetail.payTime) }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-tag
              :type="[4].some(i => i === orderDetail.orderStatus) ? 'success' : 'warning'"
              style="margin-right: 10px"
              v-if="![0, 7].some(i => i === orderDetail.orderStatus)"
            >
              {{ orderStatus[orderDetail.orderStatus] }}
            </el-tag>
            <el-tag
              :type="[6].some(i => i === orderDetail.fulfillmentStatus) ? 'success' : 'warning'"
              style="margin-right: 10px"
              v-if="orderDetail.fulfillmentStatus"
            >
              {{ FULFILMENTSTATUS[orderDetail.fulfillmentStatus] }}
            </el-tag>
            <el-tag
              :type="[1, 5, 6].some(i => i === orderDetail.payStatus) ? 'success' : 'warning'"
              style="margin-right: 10px"
            >
              {{ PAY_STATUS[orderDetail.payStatus] }}
            </el-tag>
            <el-tag
              :type="[2, 4].some(i => i === orderDetail.salesStatus) ? 'success' : 'warning'"
              style="margin-right: 10px"
              v-if="orderDetail.salesStatus > 0"
            >
              {{ SALES_STATUS[orderDetail.salesStatus] }}
            </el-tag>
          </el-row>
          <el-divider class="full-divider mb-0"></el-divider>
          <div class="goods-wrap">
            <div class="goods-item" v-for="row in orderDetail.orderItems" :key="row.orderItemNo">
              <ZImg
                :preview-src-list="[row.imageUrl]"
                :src="row.imageUrl"
                alt
                class="order-item-img"
                fit="contain"
              ></ZImg>
              <div class="goods-title">
                <el-tooltip :content="row.title" effect="dark" placement="top">
                  <div class="flex order-item-title-box">
                    <a @click="$router.push(`/products-info/detail/${row.spuId}`)" class="order-item-title">
                      {{ row.title }}
                    </a>
                  </div>
                </el-tooltip>
                <p class="order-item-desc">
                  {{ $dataCheck(row.variantOptionValue) }}{{ filterVariant(row.variantCustomizedOption) }}
                </p>
                <p class="order-item-desc">SPU ID：{{ $dataCheck(row.spuId) }}</p>
                <p class="order-item-desc">SKU ID：{{ $dataCheck(row.variantId) }}</p>
                <p class="order-item-desc">{{ $t('system::responsible::供应商') }}：{{ $dataCheck(row.supplier) }}</p>
              </div>
              <div class="goods-price">
                {{ row.variantPrice | formatNumberMix }} {{ row.currency || '' }} x {{ row.quantity }}
              </div>
              <div class="goods-price" style="color: #010517; font-weight: bold">
                {{ row.saleAmount | formatNumberMix }} {{ row.currency || '' }}
              </div>
            </div>
          </div>
          <el-divider class="full-divider mt-0"></el-divider>
          <div class="row-sale-wrapper">
            <div class="sale-item">
              <span>{{ $t('stores::order::goods') }}：</span>
              <span class="info">
                {{ $dataCheck(orderDetail.itemsAmount, 0) | formatNumberMix }} {{ orderDetail.currency }}
              </span>
            </div>
            <div class="sale-item">
              <span>{{ $t('stores::order::freight') }}：</span>
              <span class="info">
                {{ $dataCheck(orderDetail.payShipAmount, 0) | formatNumberMix }} {{ orderDetail.currency }}
              </span>
            </div>
            <div class="sale-item">
              <span>{{ $t('stores::order::tax_amount') }}：</span>
              <span class="info">
                {{ $dataCheck(orderDetail.taxAmount, 0) | formatNumberMix }} {{ orderDetail.currency }}
              </span>
            </div>
            <div class="sale-item">
              <span>{{ $t('stores::order::discount') }}：</span>
              <span class="info">
                {{ $dataCheck(orderDetail.discountsAmount, 0) | formatNumberMix }} {{ orderDetail.currency }}
              </span>
            </div>
            <div class="sale-item">
              <span>{{ $t('stores::order::order_fee') }}：</span>
              <span class="info">
                {{ $dataCheck(orderDetail.payTotalAmount, 0) | formatNumberMix }} {{ orderDetail.currency }}
              </span>
            </div>
          </div>
        </el-card>
        <el-card class="order-stream-wrapper">
          <div class="title-line" slot="header">
            <span>
              <span class="card-title">{{ $t('stores::order::shipping_info') }}</span>
              <span class="order-stream-type">
                {{ $t('stores::order::deliver_plan') }}:
                <span>{{ $dataCheck(orderDetail.shippingTitle) }}</span>
              </span>
            </span>
            <div class="right-ctl-wrapper">
              <el-button
                @click="handleSend"
                class="ctl-btn"
                size="small"
                type="primary"
                v-auth="'stores::order::ship'"
                v-if="
                  (orderDetail.orderItems || []).some(
                    item => item.fulfillmentStatus === 1 || item.fulfillmentStatus === 2
                  ) && [1].some(i => i === orderDetail.payStatus)
                "
              >
                {{ $t('stores::order::deliver') }}
              </el-button>
              <el-button
                @click="markVisible = true"
                class="ctl-btn"
                size="small"
                type="primary"
                v-auth="'stores::order::deliver'"
                v-if="
                  orderDetail.fulfillments &&
                  orderDetail.fulfillments.filter(i => i.fulfillmentStatus === 3).length &&
                  [2, 3, 5].some(i => i === orderDetail.fulfillmentStatus)
                "
              >
                {{ $t('stores::order::mask_to_place') }}
              </el-button>
            </div>
          </div>
          <template v-if="orderDetail.fulfillments && orderDetail.fulfillments.length">
            <div class="mb-20" :key="index" v-for="(item, index) in orderDetail.fulfillments">
              <div class="track-wrap">
                <div class="track-item" v-if="item.pushStatus === 1">
                  {{ $t('stores::order::fulfilments') }}：{{ $dataCheck(item.trackingCompany) }}
                </div>
                <div class="track-item" v-else>
                  {{ $t('stores::order::fulfilments') }}：
                  <span style="color: red">{{ $t('stores::order::cant_Identify') }}</span>
                  <el-popover
                    :title="$t('stores::order::fulfilments')"
                    @hide="shippingCompanyId = ''"
                    trigger="click"
                    v-model="item.showPopover"
                  >
                    <z-select :options="sendOptions" v-model="shippingCompanyId"></z-select>
                    <div style="margin-top: 10px; tet-align: center">
                      <el-button @click="chooseDeliver(item.fulfillmentId)" style="width: 100%" type="primary">
                        {{ $t('system::common::btn::confirm') }}
                      </el-button>
                    </div>
                    <i class="el-icon-edit-outline edit-icon" slot="reference"></i>
                  </el-popover>
                </div>
                <div class="track-item">
                  {{ $t('stores::order::shipping_time') }}：{{ $dataCheck(item.fulfillmentTime) }}
                </div>
                <div class="track-item">
                  {{ $t('stores::order::fulfilment_number') }}：{{ $dataCheck(item.trackingNumber) }}
                  <a :href="`https://17track.net/en#nums=${item.trackingNumber}`" target="_blank">
                    {{ $t('stores::order::check') }}
                    <i class="el-icon-arrow-right"></i>
                  </a>
                </div>
                <div class="track-item">
                  {{ $t('stores::order::status') }}：
                  <span style="color: #ff9e00">
                    {{
                      item.fulfillmentStatus === 4
                        ? $t('stores::order::online_not_sign')
                        : item.fulfillmentStatus === 6
                        ? $t('stores::order::online_sign')
                        : $t('stores::order::not_online_not_sign')
                    }}
                  </span>
                </div>
              </div>
              <div class="limitNumber mt-10" v-if="item.fulfillmentItems.length > 3">
                <div class="limit-img-wrap">
                  <template v-for="(i, idx) in item.fulfillmentItems">
                    <ZImg
                      :key="i.skuCode"
                      :preview-src-list="[i.imageUrl]"
                      :src="i.imageUrl"
                      class="order-item-img"
                      style="margin-right: 10px"
                      fit="contain"
                      v-if="idx < 6"
                    ></ZImg>
                  </template>
                  <div class="order-item-img flex-center" v-if="item.fulfillmentItems.length > 5">
                    <i class="el-icon-more"></i>
                  </div>
                </div>
                <div @click="item.showMore = !item.showMore" class="more-wrap">
                  <span>{{ $t('stores::order::fulfilment_goods', { goodsNum: item.fulfillmentItems.length }) }}</span>
                  <span class="more-btn">
                    {{ item.showMore ? $t('stores::order::put_awary') : $t('stores::order::open') }}
                  </span>
                </div>
                <div class="more-goods-wrap mt-10" v-show="item.showMore">
                  <div class="goods-item" v-for="row in item.fulfillmentItems" :key="row.orderItemNo">
                    <ZImg
                      :preview-src-list="[row.imageUrl]"
                      :src="row.imageUrl"
                      alt
                      class="order-item-img"
                      fit="contain"
                    ></ZImg>
                    <div class="goods-title">
                      <el-tooltip :content="row.title" effect="dark" placement="top">
                        <div class="flex order-item-title-box">
                          <a @click="$router.push(`/products-info/detail/${row.spuId}`)" class="order-item-title">
                            {{ row.title }}
                          </a>
                        </div>
                      </el-tooltip>
                      <p class="order-item-desc">
                        {{ $dataCheck(row.variantOptionValue) }}{{ filterVariant(row.variantCustomizedOption) }}
                      </p>
                      <p class="order-item-desc">SPU ID：{{ $dataCheck(row.spuId) }}</p>
                      <p class="order-item-desc">SKU ID：{{ $dataCheck(row.variantId) }}</p>
                      <p class="order-item-desc">
                        {{ $t('system::responsible::供应商') }}：{{ $dataCheck(row.supplier) }}
                      </p>
                    </div>
                    <div class="goods-price">
                      {{ row.variantPrice | formatNumberMix }} {{ row.currency || '' }} x {{ row.quantity }}
                    </div>
                    <div class="goods-price" style="color: #010517; font-weight: bold">
                      {{ row.saleAmount | formatNumberMix }} {{ row.currency || '' }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="goods-wrap" v-else>
                <div class="goods-item" v-for="row in item.fulfillmentItems" :key="row.orderItemNo">
                  <ZImg
                    :preview-src-list="[row.imageUrl]"
                    :src="row.imageUrl"
                    alt
                    class="order-item-img"
                    fit="contain"
                  ></ZImg>
                  <div class="goods-title">
                    <el-tooltip :content="row.title" effect="dark" placement="top">
                      <div class="flex order-item-title-box">
                        <a @click="$router.push(`/products-info/detail/${row.spuId}`)" class="order-item-title">
                          {{ row.title }}
                        </a>
                      </div>
                    </el-tooltip>
                    <p class="order-item-desc">
                      {{ $dataCheck(row.variantOptionValue) }}{{ filterVariant(row.variantCustomizedOption) }}
                    </p>
                    <p class="order-item-desc">SPU ID：{{ $dataCheck(row.spuId) }}</p>
                    <p class="order-item-desc">SKU ID：{{ $dataCheck(row.variantId) }}</p>
                    <p class="order-item-desc">
                      {{ $t('system::responsible::供应商') }}：{{ $dataCheck(row.supplier) }}
                    </p>
                  </div>
                  <div class="goods-price">
                    {{ row.variantPrice | formatNumberMix }} {{ row.currency || '' }} x {{ row.quantity }}
                  </div>
                  <div class="goods-price" style="color: #010517; font-weight: bold">
                    {{ row.saleAmount | formatNumberMix }} {{ row.currency || '' }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="no-stream-wrapper" v-else>
            <div class="no-stream-info">
              {{ $t('stores::order::not_deliver_tips') }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="8" :md="8" :sm="12" class="order-wrapper">
        <el-card>
          <div class="order-info-title">
            <span>{{ $t('stores::order::customer_info') }}</span>
            <el-button @click="editCustomer" type="primary" size="small" v-auth="'stores::order::edit'">
              {{ $t('stores::order::edit') }}
            </el-button>
          </div>
          <div class="cell-item">
            <span class="title">First name:</span>
            <span class="info">{{ $dataCheck(orderDetail.firstName) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">Last name:</span>
            <span class="info">{{ $dataCheck(orderDetail.lastName) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">Phone NO:</span>
            <span class="info">{{ $dataCheck(orderDetail.phone) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">Email:</span>
            <span class="info">{{ $dataCheck(orderDetail.email) }}</span>
          </div>
          <el-divider class="full-divider"></el-divider>
          <div class="order-info-title">{{ $t('stores::order::receiving_info') }}</div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::country') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.shippingCountry) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::province') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.shippingProvince) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::city') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.shippingCity) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::street') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.shippingAddress1) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::apartment') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.shippingAddress2) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">Code:</span>
            <span class="info">{{ $dataCheck(orderDetail.shippingZip) }}</span>
          </div>
          <el-divider class="full-divider"></el-divider>
          <div class="order-info-title">{{ $t('stores::order::billing_info') }}</div>
          <div
            class="cell-item"
            v-if="
              orderDetail.firstName === orderDetail.billingFirstName &&
              orderDetail.lastName === orderDetail.billingLastName &&
              orderDetail.shippingAddress1 === orderDetail.billingAddress1 &&
              orderDetail.shippingAddress2 === orderDetail.billingAddress2 &&
              orderDetail.shippingZip === orderDetail.billingZip
            "
          >
            <span class="title">{{ $t('stores::order::same_address') }}</span>
          </div>
          <template v-else>
            <div class="cell-item">
              <span class="title">Name:</span>
              <span class="info">{{ orderDetail.billingFirstName }} {{ orderDetail.billingLastName }}</span>
            </div>
            <div class="cell-item">
              <span class="title">Address:</span>
              <span class="info">{{ orderDetail.billingAddress1 }} {{ orderDetail.billingAddress2 }}</span>
            </div>
            <div class="cell-item">
              <span class="title">Code:</span>
              <span class="info">{{ $dataCheck(orderDetail.billingZip) }}</span>
            </div>
          </template>
          <el-divider class="full-divider"></el-divider>
          <div class="order-info-title">{{ $t('stores::order::other_info') }}</div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::pay_type') }}:</span>
            <span class="info">{{ payTypes[orderDetail.payType] || orderDetail.gateway }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::pay_time') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.payTime) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::pay_number') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.paymentNo) }}</span>
          </div>
          <div class="cell-item">
            <span class="title">{{ $t('stores::order::utmSource') }}:</span>
            <span class="info">{{ $dataCheck(orderDetail.utmSource) }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="8" :md="8" :sm="12" class="order-wrapper" style="margin-top: 16px">
        <el-card>
          <div
            class="order-info-title"
            style="display: flex; justify-content: space-bewteen; align-items: center"
            slot="header"
          >
            <span style="font-weight: bold; font-size: 16px">{{ $t('stores::order::售后信息') }}</span>
            <span
              style="font-size: 14px; color: #ff4d00"
              v-if="orderDetail.refundOrderVoList && orderDetail.refundOrderVoList.length"
            >
              {{ $t('stores::order::剩余可退款金额') }} ${{ $dataCheck(refundTotalMoney, 0) | formatNumberMix }}
            </span>
          </div>
          <template v-if="orderDetail.refundOrderVoList && orderDetail.refundOrderVoList.length">
            <el-row
              v-for="item in orderDetail.refundOrderVoList"
              :key="item.id"
              type="flex"
              align="center"
              class="refund-item"
            >
              <el-col :span="14">
                <el-button type="text" style="padding: 0" @click="$router.push(`/after-order-detail/${item.id}`)">
                  {{ item.refundNo }}
                </el-button>
              </el-col>
              <el-col :span="5">
                <span>${{ $dataCheck(item.amount, 0) | formatNumberMix }}</span>
              </el-col>
              <el-col :span="5" style="text-align: end">
                <span>{{ $dataCheck(refundStatus[item.status]) }}</span>
              </el-col>
            </el-row>
          </template>
          <div v-else style="text-align: center; color: #999; line-height: 40px">
            {{ $t('system::common::btn::no_data') }}
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :title="$t('stores::order::edit_address')" :visible.sync="editVisible" width="720px">
      <el-row :gutter="24">
        <el-form :model="editForm" :rules="rules" label-position="top" ref="editForm">
          <el-col :span="24">
            <el-form-item :label="$t('stores::order::receiver')">
              <el-input :value="`${editForm.firstName} ${editForm.lastName}`" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="First Name" prop="firstName">
              <el-input
                clearable
                v-model="editForm.firstName"
                :placeholder="`${$t('system::common::input_holder')}First Name`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Last Name" prop="lastName">
              <el-input
                clearable
                v-model="editForm.lastName"
                :placeholder="`${$t('system::common::input_holder')}Last Name`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::email')" prop="email">
              <el-input
                clearable
                v-model="editForm.email"
                :placeholder="`${$t('system::common::input_holder')}${$t('stores::order::email')}`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::country')" prop="country">
              <el-select
                @change="changeCountry"
                clearable
                filterable
                style="width: 100%"
                v-model="editForm.countryCode"
                :placeholder="`${$t('system::common::select_placeholder')}${$t('stores::order::city')}`"
              >
                <el-option :key="i.code" :label="i.name" :value="i.code" v-for="i in countries"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::province')">
              <el-select
                @change="changeProvince"
                clearable
                filterable
                style="width: 100%"
                v-model="editForm.provinceCode"
                :placeholder="`${$t('system::common::select_placeholder')}${$t('stores::order::city')}`"
              >
                <el-option :key="i.code" :label="i.name" :value="i.code" v-for="i in provinces"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::city')" prop="city">
              <el-input
                clearable
                v-model="editForm.city"
                :placeholder="`${$t('system::common::input_holder')}${$t('stores::order::city')}`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::street')" prop="address1">
              <el-input
                clearable
                v-model="editForm.address1"
                :placeholder="`${$t('system::common::input_holder')}${$t('stores::order::street')}`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::apartment')">
              <el-input
                clearable
                v-model="editForm.address2"
                :placeholder="`${$t('system::common::input_holder')}${$t('stores::order::apartment')}`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::phone')" prop="phone">
              <el-input
                clearable
                v-model="editForm.phone"
                :placeholder="`${$t('system::common::input_holder')}${$t('stores::order::phone')}`"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('stores::order::zip')" prop="zip">
              <el-input
                clearable
                v-model="editForm.zip"
                :placeholder="`${$t('system::common::input_holder')}${$t('stores::order::zip')}`"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span class="dialog-footer" slot="footer">
        <el-button @click="editVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="submitForm" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('stores::order::mark')" :visible.sync="markVisible" width="500px">
      <div class="mark_wrap">
        <div>{{ $t('stores::order::select_fulfilment') }}</div>
        <el-checkbox-group v-model="trackingNumbers">
          <template v-for="i in orderDetail.fulfillments">
            <el-checkbox
              :key="i.trackingNumber"
              :label="i.trackingNumber"
              class="checkbox-style"
              v-if="i.fulfillmentStatus === 3"
            >
              {{ i.trackingCompany }} {{ i.trackingNumber }}
            </el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="markVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="markSubmit" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
      </span>
    </el-dialog>
    <!-- 取消弹窗 -->
    <el-dialog :title="$t('stores::order::message_cancel')" :visible.sync="isCancelModalShow" width="40%">
      <p style="margin-bottom: 10px">{{ $t('stores::order::platform_order') }}：{{ orderDetail.orderNo }}</p>
      <p style="margin-bottom: 10px">{{ $t('stores::order::store_order') }}：{{ orderDetail.sourceNo }}</p>
      <p>{{ $t('stores::order::message_cancel_tips') }}</p>
      <span class="dialog-footer" slot="footer">
        <el-button @click="isCancelModalShow = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="cancelOrder" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
      </span>
    </el-dialog>
    <ShipDialog :orderDetail="orderDetail" @getDetail="getDetail" v-model="shipLoading"></ShipDialog>
  </div>
</template>
<script>
import {
  getOrderDetail,
  getAllCountry,
  getProvince,
  getSendDeliver,
  putOrderDelivery,
  updateCustomerData,
  getOrderList,
  getCancelOrder,
  updateFulfillment,
} from '@/server/order'
import { _local } from '@/utils/storage'
import ShipDialog from '../components/shipDialog'
import { formatNumberMix } from '@/utils/index'
import { ORDER_STATUS, PAY_TYPE, PLATFORM, SALES_STATUS, FULFILMENTSTATUS, PAY_STATUS } from '@/config'
import { phoneVerification } from '@/utils/verification'
import { filterVariant } from '@/utils/utils'
import { refundStatus } from '@/views/after-sales/list/config/index'
export default {
  name: 'OrderDetail',
  components: { ShipDialog },
  data() {
    const validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('stores::order::rule_phone_empty')))
      } else if (!phoneVerification(value)) {
        callback(new Error(this.$t('stores::order::rule_phone')))
      } else {
        callback()
      }
    }
    return {
      pageOrderNo: '',
      pageIndex: 0,
      activeNames: '1',
      orderDetail: {},
      pageList: _local.get('orderNumberList'),
      orderStatus: ORDER_STATUS,
      payTypes: PAY_TYPE,
      SALES_STATUS,
      FULFILMENTSTATUS,
      PLATFORM,
      PAY_STATUS,
      orderDetailItems: [
        {
          prop: 'imageUrl',
          width: 100,
        },
        {
          prop: 'title',
          width: 300,
        },
        {
          prop: 'price',
          align: 'right',
        },
        {
          prop: 'saleAmount',
          align: 'right',
        },
      ],
      loading: false,
      editVisible: false,
      markVisible: false, // 标注弹窗
      shipLoading: false, // 发货弹窗
      trackingNumbers: [],
      sendOptions: [],
      shippingCompanyId: '',
      refundStatus,
      editForm: {
        firstName: '',
        lastName: '',
        email: '',
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        // cityCode: '',
        address1: '',
        address2: '',
        phone: '',
        zip: '',
      },
      countries: [],
      provinces: [],
      citys: [],
      isCancelModalShow: false,
      rules: {
        firstName: [{ required: true, message: this.$t('stores::order::rule_first_name'), trigger: 'blur' }],
        lastName: [{ required: true, message: this.$t('stores::order::rule_last_name'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('stores::order::rule_email'), trigger: 'blur' },
          { type: 'email', message: this.$t('stores::order::rule_right_email') },
        ],
        country: [{ required: true, message: this.$t('stores::order::rule_country'), trigger: 'change' }],
        city: [{ required: true, message: this.$t('stores::order::rule_city'), trigger: 'change' }],
        address1: [{ required: true, message: this.$t('stores::order::rule_address1'), trigger: 'blur' }],
        phone: [{ required: true, validator: validPhone, trigger: 'blur' }],
        zip: [{ required: true, message: this.$t('stores::order::rule_zip'), trigger: 'blur' }],
      },
    }
  },
  mounted() {
    this.getCountry()
    this.getSendDeliver()
    // this.getDetail(this.$route.params.id)
    // if (this.$store.state.order.orderQuery&& this.$store.state.order.orderQuery.query) {
    //   this.$store.state.order.orderQuery.query(null, this.$store.state.order.orderQuery.params, (all)=> {

    //   })
    // }
  },
  activated() {
    if (this.pageOrderNo !== this.$route.params.id) {
      this.pageOrderNo = this.$route.params.id
      this.pageIndex = this.pageList.findIndex(item => item === this.pageOrderNo)
      this.getDetail(this.$route.params.id)
    }
  },
  computed: {
    refundTotalMoney() {
      let money = 0
      if (this.orderDetail.refundOrderVoList) {
        this.orderDetail.refundOrderVoList.forEach(el => {
          money += Number(el.amount)
        })
      }
      return formatNumberMix(this.orderDetail.payTotalAmount - money, 2) - this.orderDetail.taxAmount
    },
  },
  // watch: {
  //   $route: {
  //     handler: function (to) {
  //       if (to.params && to.params.id) {
  //         this.pageOrderNo = to.params.id
  //         this.pageIndex = this.pageList.findIndex(item => item === this.pageOrderNo)
  //         this.getDetail(to.params.id)
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    onPage(step) {
      const orderNo = this.pageList[this.pageIndex + step]
      this.$router.replace(`/orderDetail/${orderNo}`)
    },
    // async getOrderListData () {
    //   const { data } = await getOrderList({ ...searchParams, ...params })
    //   if (data.code === this.$code) {
    //     this.orderList = data.data.items
    //     this.pagination.total = data.data.totalCount ? data.data.totalCount : 0
    //   }
    // },
    filterVariant,
    handleSend() {
      if (
        this.orderDetail.orderItems
          .filter(item => item.fulfillmentStatus === 1 || item.fulfillmentStatus === 2)
          .every(item => item.salesStatus > 0)
      ) {
        return this.$message.warning(this.$t('stores::order::message_deliver'))
      }
      this.shipLoading = true
    },
    async chooseDeliver(number) {
      if (!this.shippingCompanyId) return this.$message.warning(this.$t('stores::order::message_fulfilment'))
      const { data } = await updateFulfillment({
        shippingCompanyId: this.shippingCompanyId,
        fulfillmentId: number,
      })
      if (data.code === this.$code) {
        this.$message.success(this.$t('stores::order::edit_fulfilment_success'))
        this.getDetail()
        this.showPopover = false
      }
    },
    async getSendDeliver() {
      var obj = {
        dictCode: 'shipping_company',
      }
      const { data } = await getSendDeliver(obj)
      if (data.code === this.$code) {
        this.sendOptions = data.data.map(item => ({
          label: item.name,
          value: item.id,
        }))
      }
    },
    async getDetail(id = this.$route.params.id) {
      this.loading = true
      const { data } = await getOrderDetail({ orderNo: id })
      if (data.code === this.$code) {
        data.data.fulfillments =
          (data.data.fulfillments &&
            data.data.fulfillments.map(item => ({
              ...item,
              showMore: false,
              showPopover: false,
            }))) ||
          []
        this.orderDetail = data.data
      }
      this.loading = false
    },
    async getCountry() {
      const { data } = await getAllCountry()
      if (data.code === this.$code) {
        this.countries = data.data
      }
    },
    async changeCountry(value) {
      this.editForm.country = this.countries.find(i => i.code === value).name
      const { data } = await getProvince(value)
      if (data.code === this.$code) {
        this.provinces = data.data
      }
      this.editForm.province = ''
      this.editForm.provinceCode = ''
      this.editForm.city = ''
    },
    async changeProvince(value) {
      this.editForm.province = this.provinces.find(i => i.code === value).name
      // const { data } = await getCity(this.editForm.countryCode, value)
      // if (data.code === this.$code) {
      //   this.citys = data.data
      // }
      this.editForm.city = ''
    },
    async changeCity(value) {
      this.editForm.city = this.citys.find(i => i.code === value).name
    },
    submitForm() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          let params = {
            orderNo: this.orderDetail.orderNo,
            ...this.editForm,
          }
          const { data } = await updateCustomerData({ ...params })
          if (data.code === this.$code) {
            this.editVisible = false
            this.$message({
              message: window.$t('system::tip::change_success'),
              type: 'success',
            })
            this.getDetail(this.$route.params.id)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async markSubmit() {
      let trackingNumbers = [...this.trackingNumbers]
      if (trackingNumbers.length === 0) return this.$message.error(this.$t('stores::order::select_fulfilment_nomber'))
      const { data } = await putOrderDelivery({
        trackingNumbers: trackingNumbers,
        order_no: this.orderDetail.orderNo,
      })
      if (data.code === this.$code) {
        this.markVisible = false
        this.$message({
          message: this.$t('stores::order::mark_success'),
          type: 'success',
        })
        this.trackingNumbers = []
        this.getDetail(this.$route.params.id)
      }
    },
    async editCustomer() {
      this.editVisible = true
      this.editForm = {
        ...this.editForm,
        firstName: this.orderDetail.firstName || '',
        lastName: this.orderDetail.lastName || '',
        email: this.orderDetail.email || '',
        phone: this.orderDetail.phone || '',
        country: this.orderDetail.shippingCountry || '',
        countryCode:
          (this.countries.find(i => i.name === this.orderDetail.shippingCountry) &&
            this.countries.find(i => i.name === this.orderDetail.shippingCountry).code) ||
          '', // 后端返回的country Code不是实时更新的
        province: this.orderDetail.shippingProvince || '',
        city: this.orderDetail.shippingCity || '',
        address1: this.orderDetail.shippingAddress1 || '',
        address2: this.orderDetail.shippingAddress2 || '',
        zip: this.orderDetail.shippingZip || '',
      }
      if (this.editForm.countryCode) {
        const { data } = await getProvince(this.editForm.countryCode)
        if (data.code === this.$code) {
          this.provinces = data.data
        }
      }
      this.editForm.provinceCode =
        (this.provinces.find(i => i.name === this.orderDetail.shippingProvince) &&
          this.provinces.find(i => i.name === this.orderDetail.shippingProvince).code) ||
        ''
    },
    async cancelOrder() {
      var obj = {
        order_no: this.orderDetail.orderNo,
      }
      const { data } = await getCancelOrder(obj)
      if (data.code === 0) {
        this.$message.success(this.$t('system::tip::cancel_success'))
        this.getDetail(this.$route.params.id)
        this.isCancelModalShow = false
      }
    },
  },
  filters: {
    formatNumberMix: formatNumberMix,
  },
}
</script>
<style lang="scss" scoped>
.order-detail {
  position: relative;
  .page-group {
    position: absolute;
    right: 0;
    z-index: 1;
    top: -48px;
    .page-btn {
      width: 32px;
      padding: 9px 9px;
      & + .page-btn {
        margin-left: 16px;
      }
    }
  }
  .title-line {
    // margin: 0 -16px;
    // padding: 0 16px;
    // border-bottom: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #010517;
  }
  .edit-icon {
    font-size: 18px;
    margin-left: 5px;
    cursor: pointer;
  }
  .detail-wrapper {
    .row-sale-wrapper {
      color: #3a416f;
      line-height: 26px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .sale-item {
        display: flex;
        justify-content: space-between;
        max-width: 250px;
        margin-bottom: 16px;
        .info {
          color: #666666;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .no-stream-wrapper {
      padding-bottom: 24px;
    }
  }
  .order-stream-wrapper {
    margin-top: 16px;
    .order-stream-type {
      margin-left: 16px;
    }
    .track-wrap {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      padding: 24px 24px 8px;
      background: #fafbfc;
      border-radius: 4px;
      .track-item {
        width: 50%;
        margin-bottom: 16px;
        a {
          margin-left: 24px;
        }
      }
    }
    .limitNumber {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .limit-img-wrap {
        display: flex;
        align-items: center;
      }
      .more-wrap {
        display: flex;
        flex-direction: column;
        font-weight: bold;
        color: #010517;
        text-align: right;
        .more-btn {
          cursor: pointer;
          margin-top: 16px;
          color: #0560fd;
          font-weight: normal;
        }
      }
    }
  }
  .order-wrapper {
    .cell-item {
      .title {
        margin-right: 8px;
      }
      .info {
        color: #666666;
      }
    }
    .order-info-title {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: bold;
      color: #010517;
    }
    .cell-item {
      line-height: 24px;
    }
  }
  .row-item {
    line-height: 24px;
  }
  .right-ctl-wrapper {
    float: right;
    padding: 3px;
  }
  .checkbox-style {
    display: block;
    margin-top: 10px;
  }
}
.refund-item {
  color: #666;
}
.refund-item + .refund-item {
  margin-top: 24px;
}
/deep/.el-card {
  color: #010517;
}
.order-item-img {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  margin-right: 24px;
  .el-icon-more {
    color: #8894a8;
    font-size: 18px;
  }
}
.goods-item {
  display: flex;
  align-items: flex-start;
  padding: 24px 0;
  border-bottom: 1px solid #dcdfe6;
  &:last-child {
    border-bottom: none;
  }
  .goods-title {
    flex: 0 0 300px;
  }
  .order-item-title {
    display: block;
    font-size: 14px;
    font-weight: bold;
    color: #010517;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis; /* 加省略号 */
    white-space: nowrap; /* 强制不换行 */
  }
  .order-item-desc {
    color: #666666;
    font-size: 12px;
    line-height: 18px;
  }
  .goods-price {
    flex: 1;
    text-align: right;
    padding: 0 16px;
  }
}
.more-goods-wrap {
  width: 100%;
  background: #f9f9f9;
  border-radius: 4px;
  .goods-item {
    padding: 24px;
  }
}
</style>
